export default "__VITE_ASSET__zRfcxnKL__"